export enum CalendarEventsStatus {
    none = 'STANDBY',
    shouldRefresh = 'SHOULD_REFRESH',
}
